<template>
  <div>
    <v-toolbar flat>
    </v-toolbar>
    <v-data-table :headers="headers" :items="device_list" :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
      <template slot="items" slot-scope="props">
        <tr :style="item_style(props.item)">
          <td style="width: 20px; max-width: 20px;">
            <v-icon :color="get_color_for_instance_status(props.item)" v-if="!is_multiple_parents(props.item)">circle</v-icon>
            
            <v-btn icon small right @click.stop="expand_device(props.item.id)" v-show="is_multiple_parents(props.item) && props.item.sub_device_list.length > 0">
              <v-icon v-if="expanded_devices.includes(props.item.id)">expand_less</v-icon>
              <v-icon v-else>expand_more</v-icon>
            </v-btn>
          </td>
          <td @click.stop="open_edit(props.item.id)">{{props.item.identifier}}</td>
          <td @click.stop="open_edit(props.item.id)">
            {{get_parent(props.item)}}
          </td>
          <td @click.stop="open_edit(props.item.id)">{{get_type_title(props.item.type)}}</td>

          <td @click.stop="open_edit(props.item.id)">
            <v-chip small @click.stop="open_content_edit_model(props.item.form_data.model, props.item.type)">{{get_content_model(props.item.form_data.model, "name")}}</v-chip>
          </td>

          <td @click.stop="open_edit(props.item.id)">
            <v-chip small @click.stop="open_content_edit(props.item.series)">{{get_content(props.item.series, "name")}}</v-chip>
          </td>

          <td @click.stop="open_edit(props.item.id)">
            <v-chip small @click.stop="open_content_edit(props.item.usage)">{{get_content(props.item.usage, "name")}}</v-chip>
          </td>

          <td @click.stop="open_edit(props.item.id)">
            <v-chip small @click.stop="open_content_edit(props.item.status)">{{get_content(props.item.status, "name")}}</v-chip>
          </td>

          <td @click.stop="open_edit(props.item.id)">
            <v-chip small @click.stop="open_content_edit(props.item.location)">{{get_content(props.item.location, "name")}}</v-chip>
          </td>

          <td class="hidden-sm-and-down" style="text-align: right; min-width: 190px; max-width: 190px; width: 190px;">
            <v-btn flat outline color="deep-orange" style="min-width: 130px; max-width: 130px;" small @click.stop="open_take_device(props.item)" v-if="is_multiple_parents(props.item) && !is_multiple_parents_subdevice(props.item)">Take device</v-btn>
          </td>

        </tr>
        <template v-if="is_multiple_parents(props.item) && !is_multiple_parents_subdevice(props.item) && expanded_devices.includes(props.item.id)">
          <tr v-for="(subdevice, index) in get_subdevices(props.item)" :key="subdevice.id" :style="item_style(props.item, index)">
            <td style="width: 20px; max-width: 20px;">
              <v-icon :color="get_color_for_instance_status(subdevice)">circle</v-icon>
            </td>
            <td @click.stop="open_edit(subdevice.id)">{{subdevice.identifier}}</td>
            <td @click.stop="open_edit(subdevice.id)">
              {{get_parent(subdevice)}}
            </td>
            <td @click.stop="open_edit(subdevice.id)">{{get_type_title(subdevice.type)}}</td>

            <td @click.stop="open_edit(subdevice.id)">
              <v-chip small @click.stop="open_content_edit_model(props.item.form_data.model, props.item.type)">{{get_content_model(props.item.form_data.model, "name")}}</v-chip>
            </td>

            <td @click.stop="open_edit(subdevice.id)">
              <v-chip small @click.stop="open_content_edit(subdevice.series)">{{get_content(subdevice.series, "name")}}</v-chip>
            </td>

            <td @click.stop="open_edit(subdevice.id)">
              <v-chip small @click.stop="open_content_edit(subdevice.usage)">{{get_content(subdevice.usage, "name")}}</v-chip>
            </td>

            <td @click.stop="open_edit(subdevice.id)">
              <v-chip small @click.stop="open_content_edit(subdevice.status)">{{get_content(subdevice.status, "name")}}</v-chip>
            </td>

            <td @click.stop="open_edit(subdevice.id)">
              <v-chip small @click.stop="open_content_edit(subdevice.location)">{{get_content(subdevice.location, "name")}}</v-chip>
            </td>

            <td class="hidden-sm-and-down" style="text-align: right; min-width: 190px; max-width: 190px; width: 190px;">
              <v-btn flat outline color="deep-orange" style="min-width: 130px; max-width: 130px;" small @click.stop="release_device(subdevice)">Release device</v-btn>
            </td>
          </tr>
        </template>
      </template>
    </v-data-table>

    <v-btn class="deep-orange" fab dark small fixed top right style="top: 90px; right: 26px;" @click.stop="open_add_device"><v-icon>add</v-icon></v-btn>
    <v-btn class="deep-orange" fab dark small fixed top right style="top: 90px; right: 396px;" @click.stop="open_read_device"><v-icon>qr_code_2</v-icon></v-btn>
    <v-btn class="dark-grey" fab dark small fixed top right style="top: 90px; right: 445px" @click.stop="show_archived = !show_archived"><v-icon>archive</v-icon></v-btn>
    <v-toolbar color="grey darken-4" fixed dense right style="top: 87px; left: auto; right: 80px; max-width: 300px;">
      <v-text-field color="deep-orange" prepend-icon="search" v-model="device_search" ref="search_field" autofocus clearable hide-details single-line></v-text-field>
    </v-toolbar>


 

  </div>
</template>

<script>

import SettingsModel from '@/models/settings.js';
import InstanceModel from '@/models/instance.js';

export default {
  data () {
    return {
      device_search: "",
      filters: {},
      expanded_devices: [],
      show_archived: false,
      pagination: {
        sortBy: 'identifier',
        descending: false,
        rowsPerPage: 25
      },
      headers: [
        { text: "", value: '', align: 'left'},
        { text: 'Indentifier', value: 'identifier', align: 'left' },
        { text: 'Parent (Free/Total)', value: 'parent', align: 'left'},
        { text: 'Type', value: 'type', align: 'left' },
        { text: 'Model', value: 'model', align: 'left' },
        { text: 'Series', value: 'series', align: 'left' },
        { text: 'Usage', value: 'usage', align: 'left'},  
        { text: 'Status', value: 'status', align: 'left' },
        { text: 'Location', value: 'location', align: 'left'},
        { text: 'Actions', align: 'right', class: "hidden-sm-and-down"}

      ],
    };
  },
  mounted () {
  },
  computed: {
    device_types() {
      return SettingsModel.list("device_type");
    },
    device_list() {
      var self = this;
      var values = _.values(this.$store.state.devices);
      
      var ret = _.filter(values, function(device) {
        if(self.is_multiple_parents_subdevice(device)) return false;
        if (self.show_archived == false) {
          if (self.get_content(device.status, "name") == "Archive") return false;
          return true;
        } else {
          if (self.get_content(device.status, "name") == "Archive") return true;
          return false;
        }
      });

      return this.filter_devices(ret);
    }
  },
  methods: {
    filter_devices(list) {
      var self = this;
      var search = (this.device_search || "").toLowerCase();
      if (search.length > 0 ) {
        list = _.filter(list, function(device) {
          var ret = false;
          if (device.identifier.toLowerCase().includes(search)) ret = true;
          if (self.get_type_title(device.type).toLowerCase().includes(search)) ret = true;
          if (self.get_content(device.location, "name").toLowerCase().includes(search)) ret = true;
          if (self.get_content(device.usage, "name").toLowerCase().includes(search)) ret = true;
          if (self.get_content(device.series, "name").toLowerCase().includes(search)) ret = true;
          if (self.get_content(device.status, "name").toLowerCase().includes(search)) ret = true;
          if (self.is_multiple_parents(device) && self.get_subdevices(device).length > 0) ret = true;
          if (self.is_multiple_parents_subdevice(device)) {
            var parent = _.get(self.$store.state.devices, _.get(device, ["meta", "multiple_parents_parent_id"]));
            if (self.get_content_model(parent.form_data.model, "name").toLowerCase().includes(search)) ret = true;
          } else {
            if (self.get_content_model(device.form_data.model, "name").toLowerCase().includes(search)) ret = true;
          }
          return ret;
        })
      }
      return list;
    },
    expand_device(id) {
      if (this.expanded_devices.includes(id)) {
        this.expanded_devices.splice(this.expanded_devices.indexOf(id), 1);
      } else {
        this.expanded_devices.push(id);
      }
    },
    get_color_for_instance_status(item) {
      if (this.is_instance_online(item)) return "green";
      return "transparent";
    },
    is_instance_online(item) {
      var instances = item.instance_list;
      var ret = false;
      _.each(instances, function(id) {
        var instance = InstanceModel.get_instance(id);
        if (InstanceModel.is_online(instance)) {
          ret = true;
        }
      });
      return ret;
    },
    get_parent(item) {
      var id = item.id;
      var parents = _.filter(this.$store.state.devices, function(device) {
        if (device.sub_device_list.includes(id)) return true;
      });

      if(this.is_multiple_parents(item) && !this.is_multiple_parents_subdevice(item)) {
        var used = _.reduce(parents, (c, parent) => { return c + _.filter(parent.sub_device_list, (id) => { return id == item.id}).length; },0) + item.sub_device_list.length;
        var total = parseInt(_.get(item, "form_data.total", 0), 10);
        var free = total - used;
        return free + " / " + total;
      }

      if (parents.length > 1) {
        return "Multiple parents"
      }

      return _.map(parents, function(parent) {
        return parent.identifier;
      }).join(", ");

    },
    get_type_title(type) {
      var setting = SettingsModel.get_by_name(type);
      if (typeof(setting) != "undefined") {
        return setting.title || type;
      }
      return type;
    },
    get_content_model(field, name) {
      if (typeof(field) != "undefined" && field != null) {
        return field[name];
      }
      return "";
    },

    get_content(field, name) {
      if (typeof(field) != "undefined" && field != null) {
        return field.data[name];
      }
      return "";
    },
    get_subdevices(item) {
      return this.filter_devices(_.values(_.filter(this.$store.state.devices, (device) => {
        return item.sub_device_list.includes(device.id);
      })));
    },
    is_multiple_parents(item) {
      var setting = SettingsModel.get_by_name(item.type);
      return _.get(setting, "value.multiple_parents", false);
    },
    is_multiple_parents_subdevice(item) {
      return _.get(item, ["meta", "multiple_parents_subdevice"], false);
    },
    item_style(item, index) {
      if(index == this.get_subdevices(item).length-1 || !this.expanded_devices.includes(item.id)) return {};
      if(this.is_multiple_parents(item) && !this.is_multiple_parents_subdevice(item) && item.sub_device_list.length > 0) {
        return {"border-bottom": "1px solid hsla(0,0%,40%,.12)"};
      }
      return {};
    },
    open_edit (id) {
      this.$router.push("/devices/devices/edit/" + id);
    },
    open_content_edit (content) {
      this.$router.push("/devices/devices/content_edit/" + content.cms_list_id +"/" + content.id);
    },
    open_content_edit_model (content, type_name) {
      var type = SettingsModel.get_by_name(type_name);
      var form = type.value.form;
      var fitem = _.find(form, function(f) {
        return f.name == "model";
      })
      var content_list_id = fitem.content_id;
      this.$router.push("/devices/devices/content_edit/" + content_list_id +"/" + content.id);
    },
    open_add_device () {
      this.$router.push("/devices/devices/new");
    },
    open_read_device () {
      this.$router.push("/devices/devices/read");
    },
    open_take_device(item) {
      var self = this;
      var ws_channel = this.$cloudserver.channel("devices:create");
      ws_channel.join();
      ws_channel.save({parent_id: item.id})
        .then((msg) => {
          self.$message.success("Device was created!");
          ws_channel.leave();
          this.$nextTick(() => {
            this.open_edit(msg.data.id);
            if (!this.expanded_devices.includes(item.id)) {
              this.expanded_devices.push(item.id);
            }
          });
        })
        .catch((msg) => {
          console.log(msg);
          self.$message.warning("Unable to create device!");
          ws_channel.leave();
        });
    },
    release_device(item) {
      var self = this;
      var ws_channel = this.$cloudserver.channel("devices:"+item.id);
      ws_channel.join();
      var push = ws_channel.push("release", {id: item.id});
      push.receive("ok", (msg) => {
        self.$message.success("Device was released!");
        ws_channel.leave();
      })
      push.receive("error", (msg) => {
        console.log(msg);
        self.$message.warning("Unable to release device!");
        ws_channel.leave();
      });
      push.receive("timeout", (msg) => {
        console.log(msg);
        self.$message.warning("Unable to release device!");
        ws_channel.leave();
      });
    }
  }
}
</script>